import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import { FDPrimaryActionButton } from '@facet-wealth/design';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { dataAttrs } from 'Helpers/Testing';

const TaxDiagnosticMessageInvitationLinkPicker = ({ resource }) => {
  const { loadPageContentLink } = usePageContentContext();

  return resource.withRelationship(
    fr.relationships.invitationLink.name,
    (rel) => (
      <FDPrimaryActionButton
        label={rel.meta('prompt')}
        onClick={() => loadPageContentLink(rel.link('related'))}
        {...dataAttrs('message-invitation-button')}
      />
    ),
    () => null,
  );
};

TaxDiagnosticMessageInvitationLinkPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
TaxDiagnosticMessageInvitationLinkPicker.defaultProps = {
};

export default TaxDiagnosticMessageInvitationLinkPicker;
